import React, { useEffect, useState } from "react"
import { Col, Container, Row, Alert } from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import { useAuth } from "../../context/AuthContext"
import CustomBreadcrumb from "../../components/CustomBreadcrumb"
import { bookOpenIcon, homeIcon } from "../../constants/icons"
import SubjectCard from "../../components/SubjectCard"

import { getSubjects } from "../../api/user/subject.api"
import SelectTopicsModal from "../../components/modal/SelectTopicsModal"

function ExamPappers() {
  const breadcrumbItems = [
    { label: <>{homeIcon}</>, path: "/" },
    { label: "All Subjects", path: "exam-papers" },
  ]

  const navigate = useNavigate()
  const { authError, clearAuthError } = useAuth()

  const [subjects, setSubjects] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [showSelectTopicsModal, setShowSelectTopicsModal] = useState(false)
  const [selectedSubjectName, setSelectedSubjectName] = useState("")
  const [selectedSubjectTopics, setSelectedSubjectTopics] = useState([])
  const [selectedSubjectId, setSelectedSubjectId] = useState(null)

  useEffect(() => {
    const fetchSubjects = async () => {
      try {
        const response = await getSubjects()
        setSubjects(response.data)
      } catch (err) {
        setError(err)
        console.error("Failed to fetch subjects:", err)
      } finally {
        setLoading(false)
      }
    }
    fetchSubjects()
  }, [])



  const handleCardClick = (subject) => {
    setSelectedSubjectName(subject.title)
    setSelectedSubjectTopics(subject.topics)
    setSelectedSubjectId(subject._id)
    setShowSelectTopicsModal(true)
  }

  const handleCloseSelectTopicsModal = () => {
    setShowSelectTopicsModal(false)
    setSelectedSubjectName("")
    setSelectedSubjectTopics([])
    setSelectedSubjectId(null)
  }

  const handleSelectTopics = (selectedTopic) => {
    if (selectedTopic) {
      navigate(`/exam-papers/${selectedSubjectName}`, {
        state: {
          subjectId: selectedSubjectId,
          topicId: selectedTopic._id,
        },
      })
    }
    handleCloseSelectTopicsModal()
  }

  return (
    <>
      <div className='breadcrum-header'>
        <Container>
          <CustomBreadcrumb breadcrumbItems={breadcrumbItems} />
        </Container>
      </div>

      {authError && (
        <Container className="mt-3">
          <Alert variant="danger"  >
            {authError}
          </Alert>
        </Container>
      )}

      <div className='subject-section'>
        <Container>
          <h2>All Subjects</h2>
          <Row>
            {loading ? (
              <p>Loading subjects...</p>
            ) : error && !authError? (
              <p>Error: {error.message}</p>
            ) : (
              subjects.map((subject, index) => (
                <Col className='mb-4' sm={6} lg={4} xl={4} xxl={2} key={index}>
                  <SubjectCard
                    onClick={() => handleCardClick(subject)}
                    iconSrc={<>{bookOpenIcon}</>}
                    imgSrc={subject.imageUrl}
                    subjectName={subject.title}
                    subjectDate={new Date(subject.createdAt).getFullYear()}
                    chapters={
                      <span>
                        {subject.topics && subject.topics.length > 0
                          ? `${subject.topics.length} Chapters`
                          : "0 Chapters"}
                      </span>
                    }
                  />
                </Col>
              ))
            )}
          </Row>
        </Container>
      </div>

      <SelectTopicsModal
        show={showSelectTopicsModal}
        onHide={handleCloseSelectTopicsModal}
        subjectName={selectedSubjectName}
        topics={selectedSubjectTopics}
        onSelectTopics={handleSelectTopics}
      />
    </>
  )
}

export default ExamPappers
